(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cheapskates-discovery"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-cs-search-suggestions]');
    if (!trigger) return;
    const modal = document.querySelector('dialog-component#search-modal');
    if (!modal) return;
    await customElements.whenDefined('dialog-component');
    customElements.upgrade(modal);
    if (typeof modal.showDialog === 'function') modal.showDialog();
  }, { capture: true });
  } catch(e) { console.error(e); }
})();

})();
